'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { List } from 'immutable';
import KeywordModal from 'AdsUI/components/campaign-details/add-entity/KeywordModal';
import KeywordBasicRecord from 'AdsUI/records/ad-management/KeywordBasicRecord';
import { AdWordsKeywordTypes, EntityTypes } from 'AdsUI/lib/Constants';
import { getKeywordTypeFromText, addKeywordTypeToText, getRawKeywordFromText } from 'AdsUI/lib/KeywordUtils';
import { usageTracker } from 'AdsUI/lib/usageTracker';
import { createKeywords } from 'AdsUI/actions/EntityManagementActions';
const DEFAULT_KEYWORD = KeywordBasicRecord({
  keywordText: '',
  matchType: AdWordsKeywordTypes.PHRASE
});
const DEFAULT_KEYWORDS = List([DEFAULT_KEYWORD]);

const KeywordModalContainer = ({
  network,
  adAccount,
  parent,
  campaignEntity,
  onClose,
  dispatch
}) => {
  const [keywords, setKeywords] = useState(DEFAULT_KEYWORDS);
  const [creating, setCreating] = useState(false);
  const [createFailed, setCreateFailed] = useState(false);
  const [showErrors, setShowErrors] = useState(false);
  useEffect(() => {
    usageTracker.track('modifyCampaign', {
      action: 'Opened create window',
      entityType: EntityTypes.KEYWORD,
      network
    });
  }, [network]);
  const onAddNewKeyword = useCallback(() => setKeywords(oldKeywords => oldKeywords.push(DEFAULT_KEYWORD)), []);
  const onChangeText = useCallback((index, newText) => {
    setKeywords(oldKeywords => {
      const matchType = getKeywordTypeFromText(newText);

      if (matchType) {
        return oldKeywords.set(index, KeywordBasicRecord({
          keywordText: newText,
          matchType
        }));
      }

      return oldKeywords.setIn([index, 'keywordText'], newText);
    });
  }, []);
  const onChangeType = useCallback((index, matchType) => setKeywords(oldKeywords => {
    const oldKeyword = oldKeywords.get(index);
    return oldKeywords.set(index, KeywordBasicRecord({
      keywordText: addKeywordTypeToText(oldKeyword.keywordText, matchType),
      matchType
    }));
  }), []);
  const onDelete = useCallback(index => setKeywords(oldKeywords => {
    if (oldKeywords.size === 1) {
      return DEFAULT_KEYWORDS;
    }

    return oldKeywords.delete(index);
  }), []);
  const onSubmit = useCallback(() => {
    if (keywords.some(keyword => !keyword.keywordText)) {
      setShowErrors(true);
      return;
    }

    setCreating(true);
    setCreateFailed(false);
    dispatch(createKeywords(adAccount.accountId, campaignEntity.id, parent.id, keywords.toArray().map(keyword => ({
      matchType: keyword.matchType,
      keywordText: getRawKeywordFromText(keyword.keywordText)
    })))).then(() => {
      onClose();
      usageTracker.track('modifyCampaign', {
        action: 'Created new children',
        entityType: EntityTypes.KEYWORD,
        network,
        createdEntityCount: keywords.size
      });
    }).catch(() => {
      // Since this dispatches an action, the failure popup should appear.
      setCreating(false);
      setShowErrors(true);
      setCreateFailed(true);
    });
  }, [dispatch, keywords, adAccount, campaignEntity, parent, onClose, network]);
  const onCancel = useCallback(() => {
    usageTracker.track('modifyCampaign', {
      action: 'Closed create window without creating',
      entityType: EntityTypes.KEYWORD,
      network
    });
    onClose();
  }, [onClose, network]);
  return /*#__PURE__*/_jsx(KeywordModal, {
    keywords: keywords,
    creating: creating,
    createFailed: createFailed,
    showErrors: showErrors,
    onAddNewKeyword: onAddNewKeyword,
    onChangeText: onChangeText,
    onChangeType: onChangeType,
    onDelete: onDelete,
    onCancel: onCancel,
    onSubmit: onSubmit
  });
};

export default connect()(KeywordModalContainer);